import React, { useState, useContext } from 'react'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Input from '../Input';
import Select from '../Select';
import styled from 'styled-components';
import animation from '../../images/animated/Animation - 1741354753629.json'
import animationFacebook from '../../images/animated/Animation - 1741616968234.json'
import PreviewFacebook from '../PreviewFacebook';
import { MarketingContext } from '../../context/marketing';
import Lottie from 'react-lottie';


const CardInput = styled.section`

    display: flex;
    width: 100%;
    margin-bottom: 0.9em;


    input,select{
        width: 100%;
        height: 50px;
        border-radius: 10px;
    }

    div > label{
        font-size: 0.9rem;
    }

    .textPrimary{
        color: black;
        font-family: "Poppins";
        font-weight: 500;
        margin-bottom: 0rem;
        font-size: 1.2rem;
    }

    div{
        margin-right:1.5rem;
    }

    @media screen and (max-width:720px){
        flex-direction: column;
        div{
            margin-left: 0rem;
        }

    }


`
const ContainerProducts = styled.div`

`
const CardWrapper = styled.div`
    width: 96%;
`
const CardAnimated = styled.div`
    display:flex;
    align-items:center ;


    p{
        font-family: "Poppins";
        font-weight: 500;
        text-align: center;
        font-size: 1.2rem;
    }

`
const ContainerPreview = styled.div`
    margin-top: 0.9rem;
    display:flex;
    align-items: center;
    justify-content: space-around;

`

const ModalBanner = (props) => {

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animation,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    }
    const defaultOptionsFacebook = {
        loop: true,
        autoplay: true,
        animationData: animationFacebook,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    }

    const {handeImage,setLink,storage,setPosition} = useContext(MarketingContext)

    const data = [
        {
            name:"Topo"
        },
        {
            name:"Horizontal"
        },
    ]



    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Informações da publicação
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>


                <CardInput>
                    <Input name={"Link do post *"} onch onChange={(e) => setLink(e.target.value)} type={"text"} />
                    <Input name={"Imagem do banner *"} accept=".png, .jpg, .jpeg" onChange={(e) => handeImage(e.target.files[0])} type={"file"} />
                </CardInput>
                <CardInput>
                    <Select name="Posição do banner" data={data} onChange={(e) => setPosition(e.target.value)} target={"name"}/>

                </CardInput>
            </Modal.Body>

            <Modal.Footer>

                <Button onClick={() => storage()}  >Adicionar Post</Button>
            </Modal.Footer>


        </Modal>
    )
}

export default ModalBanner